import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@Component({
   selector: 'app-dashboard-task-actions-summary',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './task-actions-summary.component.html',
   styleUrls: ['./task-actions-summary.component.scss']
})
export class TaskActionsSummaryComponent {
   @Input() unclaimedCount = 0;
   @Input() outstandingCount = 0;
   @Input() followUpCount = 0;
   @Input() isClaiming = false;

   @Output() claimAll = new EventEmitter<void>();
   @Output() viewFollowUps = new EventEmitter<void>();
   @Output() reviewTasks = new EventEmitter<void>();
   @Output() expandUnclaimed = new EventEmitter<void>();

   onClaimAll(): void {
      if (this.unclaimedCount === 0 || this.isClaiming) {
         return;
      }

      this.claimAll.emit();
   }

   onReviewTasks(): void {
      if (this.outstandingCount === 0) {
         return;
      }

      this.reviewTasks.emit();
   }

   onViewFollowUps(): void {
      this.viewFollowUps.emit();
   }

   onExpandUnclaimed(): void {
      this.expandUnclaimed.emit();
   }
}
